export default "__VITE_ASSET__BohcQhYa__"